import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Model_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_MODEL_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'WB Model Id', columnResourceName: 'colId', alignment: HorizAlignment.Left},
        domainOptions: {}
    },
    MODEL_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Model Name', columnResourceName: 'colName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    MODEL_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Model Id', columnResourceName: 'colPId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    MODEL_FORMULA: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Model Formula', columnResourceName: 'colFormula', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 500}
    },
    MODEL_TYPE: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Model Type', columnResourceName: 'colType', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    MODEL_UOM: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Unit of Measure', columnResourceName: 'colUOM', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    RESIDUAL_METHOD: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Residual Method',
            columnResourceName: 'colResidualMethod',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 256}
    },
    WB_TREE_FOLDER_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'Tree Folder'}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }


};

const ModelSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_MODEL_ID',
        id_ui: 'MODEL_ID',
        name: 'MODEL_NAME'

    },

    searchProviderFields: vUI_Model_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Model_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
};

const ModelSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "ModelSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'MODEL_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'MODEL_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'MODEL_ID', 'MODEL_NAME', 'MODEL_TYPE',"CREATED_DTTS", "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ModelSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ModelSearch: ISearch = {
    searchName: "Find Model",
    renderOptions: {ui5ResourceId: "ModelSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ModelSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("ModelBO", "Model", ModelSearch, "Model Search")

export {ModelSearch}